import type { FetchModelResponse } from '@cian/http-api';
import { UnknownError } from '@cian/peperrors/shared';

import { TAddFavoriteResponse } from '../../../../repositories/favorites/v1/add-favorite';
import { IAddFavoriteResponse } from '../../../../repositories/favorites/entities/add_favorite/AddFavoriteResponse';

export function assertUnknownError(
  response: TAddFavoriteResponse,
): asserts response is FetchModelResponse<200, 'json', IAddFavoriteResponse> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new UnknownError({
    domain: 'src/shared/services/favorite/addFavorite#assertUnknownError()',
    message: message || '',
    details: {
      errors: JSON.stringify(errors),
    },
  });
}
